import Alergen from "../../model/inscripcions/Alergen";

const apiUrl = process.env.REACT_APP_API_URL;
export const PutAlergens = async ( alergen : Alergen, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/alergens/${alergen.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(alergen)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};